/*
 * @Author: caiqin.xie
 * @since: 2023-07-20 09:53:13
 * @lastTime: 2023-07-20 14:28:19
 * @LastEditors: caiqin.xie
 * @message: 
 */
import React from "react";
import styles from "./index.module.scss";

interface IgameItem {
  id: string,
  gameImg: string,
  title: string,
  content: string
}
interface IProps {
  gameData: IgameItem,
  className?: string,
  contentClassName?: string,
  ctry?: string
}

const GameItem = (props: IProps) => { 
  const { gameData, className, contentClassName} = props
  return (
    <div className={`${styles['game-list-item']} ${className}`}>
      <div className={styles['game-pic']}><img src={gameData.gameImg} alt="游戏图片" /></div>
      <div className={`${styles['game-content']} ${contentClassName}`}>
        <h3 className={styles['game-title']}>{gameData.title}</h3>
        <p className={styles['game-desc']}>{gameData.content}</p>
        <span className={styles['load-more-purple']}>Explore more</span>
      </div>
    </div>
  )
}
export default GameItem 